module.exports = __webpack_public_path__ + "ad-carousel-title-2dc60314.png";